(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXPrefixDetailController', CloudPBXPrefixDetailController);

    CloudPBXPrefixDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBXPrefix', 'CloudPBX'];

    function CloudPBXPrefixDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBXPrefix, CloudPBX) {
        var vm = this;

        vm.cloudPBXPrefix = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:cloudPBXPrefixUpdate', function(event, result) {
            vm.cloudPBXPrefix = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
